import React, { useEffect, useState, Fragment } from "react";
import { useDispatch } from "react-redux";
import { classInfo } from "../../../../Store/api/classApi";
// import arrow from "/images/arrow.svg";
import arrow from "../../../../assets/images/arrow.svg";
import "../tabs.css";

const Overview = ({
  classDetail,
  currentDate,
  dateAfterSeven,
  submittedDueActivities,
  dueNextActivities,
}) => {
  const dispatch = useDispatch();
  // const cummulativeGrade = 100;
  const cummulativeGrade = (() => {
    const gradedActivities =
      classDetail?.classData?.allActivityAnswers?.filter((x) => x.isGraded) ||
      [];

    // Total grade calculation
    const totalGrade = gradedActivities.reduce(
      (acc, next) =>
        acc +
        (next.answers.length
          ? next.answers.reduce(
              (a, b) => a + (b.hasOwnProperty("grade") ? b.grade || 0 : 0),
              0
            )
          : 0),
      0
    );

    // Number of graded activities
    const gradedCount = gradedActivities.length || 1;

    // Cumulative grade
    return Math.round(totalGrade / gradedCount);
  })();

  return (
    <div
      className="tab-pane fade show active"
      id="Contents"
      role="tabpanel"
      aria-labelledby="Contents-tab"
    >
      <div className="class_details_classroom_wrap" id="myContents">
        <Fragment>
          <div className="class_details_class_info" style={{ width: "50%" }}>
            <h1>
              {classDetail.classData.courseName}
              <a href="#!">
                <img src={arrow} alt="arrow" />
              </a>
            </h1>
            <div className=" class_details_class_info_sub_headings_wrapper font_inter">
              <h2>Cuml. Grade</h2>
              <div className="grade_indicator">
                <p
                  className="mb-0"
                  style={{
                    width: `${
                      cummulativeGrade > 0 ? cummulativeGrade : "default"
                    }%`,
                    paddingRight: "5px",
                    textAlign: "end",
                    background: `${
                      cummulativeGrade >= 50
                        ? "#CDE5E1"
                        : cummulativeGrade === 0
                        ? "#ffff"
                        : "#f5c8c8"
                    }`,
                  }}
                >
                  {cummulativeGrade > 0 ? cummulativeGrade : "--"}%
                </p>
              </div>
            </div>
            <div className=" class_details_class_info_sub_headings_wrapper font_inter">
              <h2 className="">Activities</h2>
              <div className="simple_text">
                <b>
                  {
                    classDetail?.classData?.allActivityAnswers?.filter(
                      (x) => x.isGraded
                    ).length
                  }{" "}
                </b>
                /{classDetail?.classData?.allActivityAnswers?.length} Completed
              </div>
            </div>
            <div className="class_details_class_info_sub_headings_wrapper font_inter">
              <h2 className=""></h2>
              <div className="simple_text">
                <b>
                  {/* {
                    [
                      ...new Map(
                        classDetail?.classData?.allActivities?.map((obj) => [
                          obj["_id"],
                          obj,
                        ])
                      ).values(),
                    ].filter(
                      (x) =>
                        new Date(x.assignedDate) > currentDate &&
                        new Date(x.assignedDate) < dateAfterSeven &&
                        x.activityAnswers.filter(
                          (acta) => acta.answers.length > 0
                        ).length > 0 &&
                        x.activityAnswers.findIndex((ans) => !ans.isGraded) > -1
                    ).length
                  } */}
                  {dueNextActivities?.length}
                </b>{" "}
                due in next 7 days
              </div>
            </div>
            <div className=" class_details_class_info_sub_headings_wrapper font_inter">
              <h2 className=""></h2>
              <div className="simple_text">
                <b>
                  {/* {
                    classDetail?.classData?.allActivityAnswers?.filter(
                      (e) => e.answers.length
                    ).length
                  } */}
                  {submittedDueActivities?.length}/
                  {classDetail?.classData?.allActivityAnswers?.length}
                </b>{" "}
                submitted
              </div>
            </div>
          </div>
        </Fragment>
      </div>
    </div>
  );
};

export default Overview;
